export const logError = (error: any) => {
    console.error(error);
};
